<template>
  <v-tooltip
    v-if="notices.length"
    v-model="showTooltip"
    bottom
    color="orange lighten-3"
    content-class="account-notice-tooltip"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        class="account-notice-btn"
        outlined
        color="warning"
        v-bind="attrs"
        v-on="on"
        @click="showTooltip = !showTooltip"
      >
        <v-icon class="mr-3">
          mdi-alert
        </v-icon>
        <span>
          Account Notice
        </span>
      </v-btn>
    </template>
    <div class="account-notice-text">
      <div
        v-for="(notice, i) in notices"
        :key="i"
      >
        {{ notice }}
      </div>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: "AccountNotice",
  props: {
    notices: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showTooltip: false,
    };
  },
}
</script>

<style>
  .account-notice-tooltip {
    opacity: 1 !important;
  }

  .account-notice-btn {
    text-transform: none;
  }

  .account-notice-text {
    color: #000;
  }
</style>
